import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CacheService {

  constructor() {
  }

  async clearCache() {
    const keys = await caches.keys();
    keys.forEach(key => {
      caches.delete(key);
    });
  }

}